import { ID } from './id';
import { LinkedItemType } from './linked-item-type';
import { Roles } from './roles';
import { Timestamp } from './timestamp';

export enum ExternalConnectionsTypes {
  Calendar = 'calendar',
}

export enum ExternalConnectionsProviders {
  Google = 'google',
  Outlook = 'outlook',
}

export enum ExternalConnectionsCapabilities {
  ReadEvents = 'read-events',
  WriteEvents = 'write-events',
  ListCalendars = 'list-calendars',
  ReadMailboxSettings = 'read-mailbox-settings',
}

export enum ExternalConnectionsStatuses {
  Connected = 'connected',
  Broken = 'broken',
}

export enum ExternalConnectionsBrokenReasons {
  MissingCredentials = 'missing-credentials',
  InvalidGrant = 'invalid-grant',
}

export enum SyncMode {
  Manual = 'manual',
  Automatic = 'automatic',
}

export enum CalendarDetailsVisibility {
  Visible = 'visible',
  Hidden = 'hidden',
}

export type ExternalConnectionGoogleProviderInfo = {
  email: string;
  id: ID;
};

export type CalendarSetting = {
  linkedItemType: LinkedItemType;
  calendarId: ID;
  mode: SyncMode;
  detailsVisibility?: CalendarDetailsVisibility;
  // Only the all-tasks setting carries this: the lower date bound (start of its creation month)
  // below which tasks are not synced. Fixed at creation, preserved across edits.
  syncTasksFrom?: Timestamp | null;
};

export type TaskCalendarOverride = {
  synced?: boolean;
  detailsVisibility?: CalendarDetailsVisibility;
};

export type ExternalConnectionGoogleSettings = {
  calendarBlacklist?: ID[] | null;
  syncedGoals?: ID[] | null;
  syncedLifeAreas?: ID[] | null;
  syncAllTasks?: boolean | null;
  calendarSettings?: Record<ID, CalendarSetting> | null;
  taskOverrides?: Record<ID, TaskCalendarOverride> | null;
};

export type ExternalConnection = {
  createdAt: Timestamp;
  lastUsedAt: Timestamp;
  id: ID;
  provider: ExternalConnectionsProviders;
  providerInfo: ExternalConnectionGoogleProviderInfo;
  roles: Roles;
  type: ExternalConnectionsTypes;
  updatedAt: Timestamp;
  settings?: ExternalConnectionGoogleSettings | null;
  // Backend-owned (client writes are rejected by firestore rules). Absent on connections
  // made before capability tracking — those hold read-only scopes and cannot write events.
  capabilities?: ExternalConnectionsCapabilities[];
  status?: ExternalConnectionsStatuses;
  brokenReason?: ExternalConnectionsBrokenReasons;
};
